import { Component, ViewEncapsulation, OnInit, ChangeDetectorRef, ViewChild, ElementRef } from "@angular/core";
import { NbAuthService } from "@nebular/auth";
import { Router } from "@angular/router";
import { StorageService } from "../../../../shared/services/storage.service";

@Component({
  selector: 'ngx-request-password',
  styleUrls: ['./request-password.component.scss'],
  templateUrl: './request-password.component.html',
  encapsulation: ViewEncapsulation.None,
  host: {
    class: 'full-screen-request-password'
  }
})
export class NgxRequestPasswordComponent implements OnInit {
  @ViewChild('requestPasswordContainer', { static: true }) requestPasswordContainer: ElementRef;
  
  user: any = {
    email: ''
  };
  
  submitted = false;
  errors: string[] = [];
  messages: string[] = [];
  showMessages = {
    error: false,
    success: false
  };
  strategy = 'email';

  constructor(
    private authService: NbAuthService,
    private cd: ChangeDetectorRef,
    private router: Router,
    private storageService: StorageService
  ) {}

  ngOnInit() {
    // Remove qualquer layout padrão do Nebular
    this.removeNebularLayout();
    
    // Carregar email salvo se existir
    this.loadSavedEmail();
    
    this.cd.detectChanges();
  }

  ngAfterViewInit() {
    // Garante que o componente ocupe toda a tela
    this.ensureFullScreen();
  }

  removeNebularLayout() {
    // Remove classes e estilos padrão do Nebular
    const body = document.body;
    body.classList.add('custom-request-password-layout');
    
    // Remove qualquer container padrão do Nebular
    const nebularContainers = document.querySelectorAll('.nb-auth, .auth-block, .auth-container');
    nebularContainers.forEach(container => {
      if (container instanceof HTMLElement) {
        container.style.display = 'none';
      }
    });
  }

  ensureFullScreen() {
    // Garante que o componente ocupe toda a tela
    if (this.requestPasswordContainer) {
      const container = this.requestPasswordContainer.nativeElement;
      container.style.width = '100vw';
      container.style.height = '100vh';
      container.style.position = 'fixed';
      container.style.top = '0';
      container.style.left = '0';
      container.style.zIndex = '9999';
    }
  }

  loadSavedEmail() {
    console.log('Carregando email salvo...');
    
    const savedCredentials = this.storageService.getLocalItem('savedCredentials');
    
    if (savedCredentials) {
      try {
        const credentials = JSON.parse(savedCredentials);
        this.user.email = credentials.email || '';
      } catch (error) {
        console.error('Erro ao carregar email salvo:', error);
      }
    } else {
      console.log('Nenhum email salvo encontrado');
    }
  }

  requestPassword(): void {
    this.submitted = true;
    this.errors = [];
    this.messages = [];
    this.showMessages.error = false;
    this.showMessages.success = false;

    this.authService.requestPassword(this.strategy, this.user).subscribe({
      next: (result: any) => {
        this.submitted = false;
        if (result.success) {
          // Traduz as mensagens de sucesso
          const originalMessages = result.getMessages();
          this.messages = originalMessages.map((message: string) => this.translateSuccessMessage(message));
          this.showMessages.success = true;
          
          // Salvar email no localStorage para uso seguro na próxima tela
          this.storageService.setLocalItem('resetPasswordEmail', this.user.email);
          
          // Redirecionar para a tela de verificação de código (sem expor email na URL)
          setTimeout(() => {
            this.router.navigate(['/auth/verify-code']);
          }, 2000);
        } else {
          // Traduz as mensagens de erro
          const originalErrors = result.getErrors();
          this.errors = originalErrors.map((error: string) => this.translateErrorMessage(error));
          this.showMessages.error = true;
        }
        this.cd.detectChanges();
      },
      error: (error) => {
        this.submitted = false;
        this.errors = ['Ocorreu um erro ao tentar solicitar o reset da senha. Por favor, tente novamente.'];
        this.showMessages.error = true;
        this.cd.detectChanges();
      }
    });
  }

  /**
   * Traduz mensagens de erro do inglês para português
   */
  private translateErrorMessage(error: string): string {
    const errorTranslations: { [key: string]: string } = {
      'Email is required!': 'E-mail é obrigatório!',
      'Email should be the real one!': 'O e-mail deve ser válido!',
      'User not found': 'Usuário não encontrado',
      'Account is locked': 'Conta está bloqueada',
      'Account is disabled': 'Conta está desabilitada',
      'Too many failed attempts': 'Muitas tentativas falharam',
      'Session expired': 'Sessão expirada',
      'Network error': 'Erro de conexão',
      'Server error': 'Erro do servidor',
      'Password reset request failed': 'Falha na solicitação de reset de senha',
      'Invalid email format': 'Formato de e-mail inválido',
      'Email not registered': 'E-mail não registrado',
      'Password reset not allowed': 'Reset de senha não permitido',
      'Rate limit exceeded': 'Limite de tentativas excedido',
      'Something went wrong, please try again.': 'Algo deu errado, por favor, tente novamente.'
    };

    // Procura por uma tradução exata
    if (errorTranslations[error]) {
      return errorTranslations[error];
    }

    // Procura por traduções parciais
    for (const [english, portuguese] of Object.entries(errorTranslations)) {
      if (error.toLowerCase().includes(english.toLowerCase())) {
        return portuguese;
      }
    }

    // Se não encontrar tradução, retorna a mensagem original
    return error;
  }

  /**
   * Traduz mensagens de sucesso do inglês para português
   */
  private translateSuccessMessage(message: string): string {
    const successTranslations: { [key: string]: string } = {
      'Password reset instructions have been sent to your email.': 'Instruções para reset de senha foram enviadas para seu e-mail.',
      'Password reset email sent': 'E-mail de reset de senha enviado',
      'Check your email for password reset instructions': 'Verifique seu e-mail para instruções de reset de senha',
      'Password reset request successful': 'Solicitação de reset de senha bem-sucedida',
      'Reset email sent successfully': 'E-mail de reset enviado com sucesso'
    };

    // Procura por uma tradução exata
    if (successTranslations[message]) {
      return successTranslations[message];
    }

    // Procura por traduções parciais
    for (const [english, portuguese] of Object.entries(successTranslations)) {
      if (message.toLowerCase().includes(english.toLowerCase())) {
        return portuguese;
      }
    }

    // Se não encontrar tradução, retorna a mensagem original
    return message;
  }

  getConfigValue(key: string): any {
    return true;
  }

  goBackToLogin(): void {
    this.router.navigate(['/auth/login']);
  }
}
